import { observer } from 'mobx-react';
import React from 'react';
import { Momentino } from '../../../services/Momentino';
import { IDataviewStore } from '../../../stores/DataviewStore';
import { useOmnistore } from '../../../stores/Omnistore';
import { SupplierItemExtended } from './SupplierItemExtended';

export const HarmoInfo = observer(function HarmoInfo(props: {entity: SupplierItemExtended, state: IDataviewStore}) {
	const {entity} = props;
	const harmonizerRepo = useOmnistore().multirepo.harmonizerRepo;
	const harmonization = entity.harmonization;

	if (!harmonization) return <div/>;
	const harmonizerId = harmonization.ownerId;
	const harmonizerName = harmonizerRepo.byId(harmonizerId)?.nickname ?? '' + harmonizerId;
	const timestamp = Momentino.timestampTo.datetime(harmonization.timestamp);
	return <div>{timestamp}<br/>{harmonizerName}</div>;
});
